import { createFileRoute } from "@tanstack/react-router";
import LoginPage from "@/app/login/LoginPage";

// Public route. Login UI + WebAuthn (@simplewebauthn/browser) are auto-split
// into their own chunk by the router plugin, so authenticated users (the common
// case) never download them.
export const Route = createFileRoute("/login")({
  component: LoginPage,
});
